import * as React from 'react'

import {Button, DatePicker, Form, Input, Select} from 'antd';
import {FormComponentProps} from "antd/lib/form";
import {observer} from "mobx-react";
import {ViewBaseComponent} from "../../../src/views/ViewComponentBase";
import KixGbcMemberLayout from "../../layouts/KixGbcMemberLayout/KixGbcMemberLayout";
import commonStyles from '../../../src/styles/common.scss';
import {InformationStore} from "../../../src/store/views/Information/InformationStore";
import appStyles from '../../assets/css/app.scss';
import {BaseValidations} from "../../../src/utils/form/validate/BaseValidations";
import {action, observable} from "mobx";
import {HistoryConstants} from "../../../src/constants/Views/Histories/HistoryConstants";
import {FastlaneService} from "../../service/FastlaneService";
import {getQueryParam} from "../../../src/utils/react/routerUtil";
import moment from "moment";
import {toDateStr} from "../../../src/utils/datetime/moment";
import {timeStore} from "../../store/TimeStore";

const FormItem = Form.Item;

@observer
class UseFastlane extends ViewBaseComponent<{} & FormComponentProps, {}> {
  informationStore: InformationStore | undefined;
  formUtils = this.props.form;
  fastLaneService = new FastlaneService(this.formUtils, 1);
  loungeService = new FastlaneService(this.formUtils, 2);
  loungeSecondService = new FastlaneService(this.formUtils, 2, 1);

  isFastlane = 1;
  isLoungeSecond = 0;

  @observable
  remaining = 0;

  @observable
  isModalVisible = false;

  componentWillMount() {
    this.informationStore = new InformationStore();

    let isLane = getQueryParam("is_lane") as string;
    this.isFastlane = parseInt(isLane);
    // if (this.isFastlane == 1) {
    //   location.href = "https://www.kansai-airport.or.jp/kix-gbc/notices/200313/";
    // }
    let loungeStr = getQueryParam("is_lounge_second") as string;
    this.isLoungeSecond = parseInt(loungeStr);
  }

  componentWillUnmount() {
    this.informationStore = void 0;

  }

  @action
  validateFlightDate = (_rule: any, value: moment.Moment, callback: (error?: string) => void): void => {
    if (toDateStr(value)! >= toDateStr(moment())! && toDateStr(value)! <= toDateStr(moment(timeStore.time).add("days", 3))!) {
      callback();
    } else {
      callback("搭乗日は本日より起算して4日後まで指定可能です。");
    }
  };


  render() {
    const {getFieldDecorator} = this.props.form;

    return (
      <KixGbcMemberLayout>
        <h2 className={appStyles.h2blue} style={{marginTop: "2em", marginBottom: "2em"}}>
          {this.isFastlane == 1 ? "Fast Lane を利用する" : "ラウンジを利用する"}
        </h2>

        <Form>
          <div className={commonStyles.fCenter}>
            <div style={{width: "80%"}}>
              <span className={appStyles.h3White}>ご搭乗日</span>
              <FormItem>
                {getFieldDecorator('flight_date', {
                  rules: [
                    BaseValidations.required,
                    {validator: this.validateFlightDate},
                  ],
                })(
                  <DatePicker placeholder="ご搭乗日を入力して下さい(例)20180131" style={{width: "100%"}} format={"YYYYMMDD"}
                              disabledDate={(value) => {
                                let flag = toDateStr(value)! >= toDateStr(moment())! && toDateStr(value)! <= toDateStr(moment(timeStore.time).add("days", 3))!;
                                return !flag;
                              }}
                  />
                )}
                <p className={appStyles.h3White}
                   style={{fontSize: "1em"}}>
                   {this.isFastlane == 1 ? "Fast Laneの許可証の有効期間は搭乗日から起算して３日間です。" : "ラウンジの許可証の有効期間は搭乗日から起算して３日間です。"}
                   </p>
              </FormItem>

              <span className={appStyles.h3White}>行先方面</span>
              <FormItem>
                {getFieldDecorator('dest', {
                  validateTrigger: "onBlur",
                  rules: [BaseValidations.required],
                })(
                  <Input size="large" placeholder="都市名を入力してください（例）ニューヨーク、北京等"/>
                )}
              </FormItem>

              <span className={appStyles.h3White}>便名</span>
              <FormItem>
                {getFieldDecorator('flight', {
                  validateTrigger: "onBlur",
                  rules: [
                    BaseValidations.required,
                    {pattern: /^[a-zA-Z0-9]{2}[0-9]{1,4}$/, message: "便名の書式が正しくありません。"},
                  ],
                })(
                  <Input size="large" placeholder="便名を入力して下さい(例)AA1234"/>
                )}
                <p className={appStyles.h3White}
                   style={{fontSize: "1em"}}>半角大文字英数字2桁+半角数字1-4桁でご入力ください。</p>
              </FormItem>

              <span className={appStyles.h3White}>クラス</span>
              <FormItem>
                {getFieldDecorator('class', {
                  validateTrigger: "onBlur",
                  rules: [BaseValidations.required],
                })(
                  <Select
                    placeholder={"クラスを選択して下さい"}
                    showSearch
                    style={{width: "20em"}}
                    optionFilterProp="children"
                    filterOption={(input, option) => option.props.children!.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  >
                    {HistoryConstants.flightClass.map((value, index) => (
                      value ? <Select.Option key={index} value={index}>{value}</Select.Option> : ""
                    ))}
                  </Select>
                )}
              </FormItem>

              {Boolean(this.isLoungeSecond) && (
                <>
                  <span className={appStyles.h3White}>ラウンジ</span>
                  <FormItem>
                    {getFieldDecorator('lounge', {
                      validateTrigger: "onBlur",
                      rules: [BaseValidations.required],
                    })(
                      <Select
                        placeholder={"ラウンジを選択して下さい"}
                        showSearch
                        style={{width: "20em"}}
                        optionFilterProp="children"
                        filterOption={(input, option) => option.props.children!.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0}
                      >
                        {HistoryConstants.useLounge.map((value, index) => (
                          value ? <Select.Option key={index} value={index}>{value}</Select.Option> : null
                        ))}
                      </Select>
                    )}
                  </FormItem>
                </>
              )}

              <div className={commonStyles.fCenter + " " + commonStyles.mt30}>
                <FormItem>
                  <Button style={{padding: "0.5em 6em 0.5em 6em", margin: "1em 0 1em 0"}} type="primary"
                          size="large" className={appStyles.buttonBlue}
                          onClick={() => {
                            if (this.isFastlane === 1) {
                              this.fastLaneService.handleConfirm(this.formUtils.getFieldValue("flight_date"));
                            } else if (Boolean(this.isLoungeSecond)) {
                              this.loungeSecondService.handleConfirm(this.formUtils.getFieldValue("flight_date"));
                            } else {
                              this.loungeService.handleConfirm(this.formUtils.getFieldValue("flight_date"));
                            }
                          }}
                  >
                    登録
                  </Button>
                </FormItem>
              </div>

              <div className={appStyles.h3White} style={{fontSize: "1em"}}>
                ※ご利用登録は不正防止の観点から<br/>
                　登録された端末バージョンでのみ表示されます。<br/>
                　PC版でご登録いただいた場合、<br/>
                　アプリ版では表示されず、双方で登録されますと2回分消化されますのでご注意ください。<br/>
              </div>

            </div>
          </div>
        </Form>

        {this.fastLaneService.displayModal()}
        {this.loungeService.displayModal()}
        {this.loungeSecondService.displayModal()}
      </KixGbcMemberLayout>
    );
  }
}

export default Form.create()(UseFastlane)

